export const CustomerStatus = {
  Onboarded:                     Symbol('onboarded'),
  OnboardedAndTradeDocSubmitted: Symbol('onboarded and trade doc submitted'),
  KYCVerified:                   Symbol('kyc verified'),
  OfferedLoanOffer:              Symbol('offered loan offer'),
};

export const evaluateStatus = (customer)=> {
  if (isOfferedALoanOffer(customer)) {
    return CustomerStatus.OfferedLoanOffer;
  } else if (isOnboardedAndTradeDocSubmitted(customer)) {
    return CustomerStatus.OnboardedAndTradeDocSubmitted;
  } else if (isOnboarded({ customer: customer, newCustomerCheck: true })) {
    return CustomerStatus.Onboarded;
  } else if (isKycVerified(customer)) {
    return CustomerStatus.KYCVerified;
  }
};

const isOnboarded = ({ customer, newCustomerCheck }) => {
  if (isKycVerified(customer)) return;

  const { ptp_submitted, btp_submitted, old_customer } = customer.onboarding || {};

  return newCustomerCheck
    ? ptp_submitted && btp_submitted && !old_customer
    : ptp_submitted && btp_submitted;
};

const isOnboardedAndTradeDocSubmitted = customer => {
  const isCustomerOnboarded = isOnboarded({ customer: customer, newCustomerCheck: false });

  return isCustomerOnboarded && isTradeDocSubmitted(customer);
}

const isTradeDocSubmitted = customer => {
  return customer.has_trade_documents;
}

const isKycVerified = customer => {
  return !!customer.kyc_verified;
};

const isOfferedALoanOffer = customer => {
  return customer.has_loan_offers_for_acceptance;
}

const isOldCustomer = (customer = {}) => {
  if(!customer || !customer.onboarding) return false;
  return customer.onboarding.old_customer;
}

export const hasAnyRejectedRequirements = (customer = {}) => {
  if (!customer.active_personal_trustpass) { return false }
  if (!customer.active_business_trustpass) { return false }
  let ptp_rejected = customer.active_personal_trustpass.are_any_requirements_rejected;
  let active_btp = customer.active_business_trustpass;
  let btp_requirements = active_btp.requirements === undefined ? [] : active_btp.requirements;
  let btp_rejected = btp_requirements.filter((r) => r.status === 'rejected').length > 0;
  return ptp_rejected || btp_rejected
}

export const shouldNotBeOnboarded = (customer = {}) => {
  if (hasAnyRejectedRequirements(customer)) { return false };
  return customer.kyc_verified_at_least_once || customer.onboarding_finished || isOldCustomer(customer);
}



// WEBPACK FOOTER //
// ./src/features/home/misc/CustomerStatus.js